// Same keys are used in CSS

export enum OutSideBetAreas {
    firstDozen = 'firstDozen',
    secondDozen = 'secondDozen',
    thirdDozen = 'thirdDozen',
    firstColumn = 'firstColumn',
    secondColumn = 'secondColumn',
    thirdColumn = 'thirdColumn',
    low = 'low',
    even = 'even',
    red = 'red',
    black = 'black',
    odd = 'odd',
    high = 'high',
}
